/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

export class StandardIntervalModel {
  startTime: string | undefined = undefined;
  endTime: string | undefined = undefined;
  errorBehavior: boolean | undefined = undefined;
}
